'use strict';

let processInclude = require('base/util');
require('core/components/spinner');
let updatedPid = '';
let selectedProductUUID = '';
let clickedProduct = '';
let currentOpenedModal = '';
let clickedSize = '';
let bodyMeasurementSwitchButtons;
let productMeasurementSwitchButtons;

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
  // let errorHtml =
  //   '<div class="alert error-message alert-dismissible valid-cart-error ' +
  //   'fade show" role="alert">' +
  //   '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
  //   '<span aria-hidden="true">&times;</span>' +
  //   '</button>' +
  //   message +
  //   '</div>';

  // $('.cart-error').append(errorHtml);
  $('.generic-cart-error').removeClass('d-none');
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
  $('.modal-body').spinner().start();
  $.ajax({
    url: editProductUrl,
    method: 'GET',
    dataType: 'json',
    success: function (data) {
      document.getElementById('main-overlay').style.display = 'block';
      document.querySelector('body').style.overflow = 'hidden';
      document.querySelector('body').style.height = '100vh';
      $('body').trigger('editproductmodal:ready');
      bindEventOpenFitGuide();
      $.spinner().stop();
      $('body').trigger('cart:edit-modal-open');
      // initFunction();
      updateCartAction();
      attributeClickBehaviour();
    },
    error: function () {
      $.spinner().stop();
    },
  });
}

const initUnitSizeChangeBehaviour = (unitSizeInputs) => {
  const toggleActiveButton = (input) => {
    unitSizeInputs && unitSizeInputs.forEach(b => b.classList.remove('-active'));
    input.target.closest('.jils-change-unit-measure').classList.add('-active');
  }
  unitSizeInputs ? unitSizeInputs.forEach(b => b.addEventListener('click', (e) => toggleActiveButton(e))) : null;
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
  for (let i = 0, l = array.length; i < l; i++) {
    if (match.call(this, array[i])) {
      return array[i];
    }
  }
  return null;
}

function getModalHtmlElement() {
  if ($('#editProductModal').length !== 0) {
    $('#editProductModal').remove();
  }
  let htmlString =
    '<!-- Modal -->' +
    '<div class="modal fade" id="editProductModal" role="dialog">' +
    '<div class="edit-modal-container">' +
    '<div class="modal-dialog quick-view-dialog">' +
    '<!-- Modal content-->' +
    '<div class="modal-content">' +
    '<div class="modal-header">' +
    ' <button type="button" class="close pull-right" data-dismiss="modal">' +
    '      <div id="close-edit-product-modal" class="modal-close" role="button" tabindex="0" aria-label="Close dialog" data-dismiss="modal" modal-close></div>' +
    ' </button>' +
    '</div>' +
    '<div class="horizontal-row edit-product-modal-header-bottom"></div>' +
    '<div class="modal-body"></div>' +
    '<div class="modal-footer"></div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>';
  $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
  let $html = $('<div>').append($.parseHTML(html));
  let body = $html.find('.product-quickview');
  let footer = $html.find('.modal-footer').children();

  return { body: body, footer: footer };
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
  let html = '';
  $('.approaching-discounts').empty();
  if (approachingDiscounts.length > 0) {
    approachingDiscounts.forEach(function (item) {
      html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
    });
  }
  $('.approaching-discounts').append(html);
}
/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
  $('.number-of-items').empty().append(data.resources.numberOfItems);
  $('.shipping-cost').empty().append(data.totals.totalShippingCost);
  $('.tax-total').empty().append(data.totals.totalTax);
  $('.grand-total').empty().append(data.totals.grandTotal);
  $('.sub-total').empty().append(data.totals.subTotal);
  $('.minicart-quantity').empty().append('(' + data.numItems + ')');
  $('.minicart-link').attr({
    'aria-label': data.resources.minicartCountOfItems,
    title: data.resources.minicartCountOfItems,
  });
  if (data.totals.orderLevelDiscountTotal.value > 0) {
    $('.order-discount').removeClass('hide-order-discount');
    $('.order-discount-total')
      .empty()
      .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
  } else {
    $('.order-discount').addClass('hide-order-discount');
  }

  if (data.totals.shippingLevelDiscountTotal.value > 0) {
    $('.shipping-discount').removeClass('hide-shipping-discount');
    $('.shipping-discount-total')
      .empty()
      .append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
  } else {
    $('.shipping-discount').addClass('hide-shipping-discount');
  }

  data.items.forEach(function (item) {
    if (item.renderedPromotions) {
      $('.item-' + item.UUID)
        .empty()
        .append(item.renderedPromotions);
    }
    if (item.priceTotal && item.priceTotal.renderedPrice) {
      $('.item-total-' + item.UUID)
        .empty()
        .append(item.priceTotal.renderedPrice);
    }
  });
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
  let lineItem;
  let messages = '';

  for (let i = 0; i < data.items.length; i++) {
    if (data.items[i].UUID === uuid) {
      lineItem = data.items[i];
      break;
    }
  }

  $('.availability-' + lineItem.UUID).empty();

  if (lineItem.availability) {
    if (lineItem.availability.messages) {
      lineItem.availability.messages.forEach(function (message) {
        messages += '<p class="line-item-attributes">' + message + '</p>';
      });
    }

    if (lineItem.availability.inStockDate) {
      messages += '<p class="line-item-attributes line-item-instock-date">' + lineItem.availability.inStockDate + '</p>';
    }
  }

  $('.availability-' + lineItem.UUID).html(messages);
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
  let lineItem = findItem(data.cartModel.items, function (item) {
    return item.UUID === uuid;
  });

  if (lineItem.variationAttributes) {
    let colorAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'color';
    });

    if (colorAttr) {
      let colorSelector =  `.productuuid-${selectedProductUUID} .color .value-field`;
      let newColor = colorAttr.displayValue;
      $(colorSelector).text(newColor);
    }

    let sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
      return attr.attributeId === 'size';
    });

    if (sizeAttr) {

      let sizeSelector = `.productuuid-${selectedProductUUID} .size .value-field`;
      let newSize = sizeAttr.displayValue;
      $(sizeSelector).text(newSize);
    }

    const imageSelector = `.product-wrapper.productuuid-${uuid} .product-image-wrapper img`;
    $(imageSelector).attr('src', lineItem.images.small[0].url);
    $(imageSelector).attr('alt', lineItem.images.small[0].alt);
    $(imageSelector).attr('title', lineItem.images.small[0].title);
  }

  if (lineItem.options && lineItem.options.length) {
    let option = lineItem.options[0];
    let optSelector = '.lineItem-options-values[data-option-id="' + option.optionId + '"]';
    $(optSelector).data('value-id', option.selectedValueId);
    $(optSelector + ' .line-item-attributes').text(option.displayName);
  }

  let qtySelector = '.quantity[data-uuid="' + uuid + '"]';
  $(qtySelector).val(lineItem.quantity);
  $(qtySelector).data('pid', data.newProductId);

  $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);
  $('.btn-cart-remove[data-uuid="' + uuid + '"]')[0].dataset.pid = data.newProductId;

  let priceSelector = '.line-item-price-' + uuid + ' .sales .value';
  $(priceSelector).text(lineItem.price.sales.formatted);
  $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

  if (lineItem.price.list) {
    let listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
    $(listPriceSelector).text(lineItem.price.list.formatted);
    $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
  }
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
  if (data.valid.error) {
    $('.generic-cart-error').removeClass('d-none');
    // $('.cart-error').append(errorHtml);
  } else {
    !$('.generic-cart-error').hasClass('d-none') && $('.generic-cart-error').addClass('d-none');
    $('.checkout-btn').removeClass('disabled');
  }
}

function updateWishlistButton(element, inWishlist) {
  $(element)
    .closest('.edit-modal-container')
    .find('button.js_add-to-wish-list')
    .each(function (i, e) {
      $(e).toggleClass('active', inWishlist);
      $(e).attr('data-pid', updatedPid);
    });
}

const bodyMeasurementTemplate = (bodyMeasurement) => {
  const changeUnitMeasureLabel = `<div class="change-unit-measure-label">${bodyMeasurement && bodyMeasurement.measurementsDescriptionLabel}</div>`;
  const changeUnitMeasureSeparator = `<div class="change-unit-measure-separator">/</div>`;
  return `
    <header class="measuring-guide__header">
      <div class="measuring-guide__header-content">
        <p class="text-measurements-guide">${bodyMeasurement.description}</p>
      </div>
      <div class="measuring-guide__toggler">
        <div class="col">
          <div class="row choose-size-radio-input-row">
            <div class="col-auto measuring-guide__radio-input -jils-measuring-guide-input">
              <div class="form-group mm-switch -md" id="body-measurements-switch">
              ${changeUnitMeasureLabel}
                <div class="radio mm-switch__toggle jils-change-unit-measure -active">
                  <label for="unit-measure_0">cm
                    <input name="unit-measure" class="body-unit-measure unit-measure" id="unit-measure_0" type="radio" value="cm" checked="">
                  </label>
                </div>
                ${changeUnitMeasureSeparator}
                <div class="radio mm-switch__toggle jils-change-unit-measure">
                  <label for="unit-measure_1">inches
                    <input name="unit-measure" class="body-unit-measure unit-measure" id="unit-measure_1" type="radio" value="in">
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="measuring-guide-content row">
      <div class="col-12">
        <div class="table table-wrapper">
          <table class="table table-striped body-measure-table">
            <thead>
              ${buildTableHeader(bodyMeasurement)}
            </thead>
            <tbody>
              ${buildTableBody(bodyMeasurement)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  `
}

function buildTableBody(bodyMeasurement) {
  let content = '';
  if(bodyMeasurement && bodyMeasurement.convertedMeasurements) {
    bodyMeasurement.convertedMeasurements.forEach((measure) => {
      content += `
        <tr>
          <td class="measure-label label fixed-side">${measure.label}</td>
          ${buildSingleRowContent(measure)}
        </tr>
      `
    })
  }
  return content;
}

function buildSingleRowContent(measure) {
  let content = '';
  if(measure && measure.values) {
    measure.values.forEach( val => {
      content += `
        <td class="js-values">
          ${val.cm ? `<span class="js-value js-cm">${val.cm}</span>` : null}
          ${val.in ? `<span class="js-value js-in d-none">${val.in}</span>` : null}
        </td>
      `
    })
  }
  return content;
}

const calcDynamicPercentWidth = (ref, length) => ``;

function buildTableHeader(bodyMeasurement) {
  let headings = '';
  if(bodyMeasurement && bodyMeasurement.headings) {
    bodyMeasurement.headings.forEach((el, index) => {
      headings += `<th style="width: ${calcDynamicPercentWidth(100, bodyMeasurement.headings.length)}" class="${index === 1 ? 'fixed-side' : ''}">${el}</th>`;
    });
  }
  return headings;
}

function bindEventOpenFitGuide() {
  $('.size-guidelines-button').on('click', function (e) {
      let url = e.currentTarget.dataset['getcontent'];
      if (url) {
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            const sizeConversionAccordion = document.querySelector('.accordion.size-conversion-accordion');
            const bodyMeasuresAccordion = document.querySelector('.accordion.body-measures-accordion');
            const productMeasuresAccordion = document.querySelector('.accordion.product-measures-accordion');
            const genderSizeConversionAccordion = document.querySelector('.accordion.gender-size-conversion-accordion');
            if (data) {
              $('#unit-measure_0').trigger('click');
              if (data.sizeListImageUrl) {
                $('.measuring-img__sketches')
                  .empty()
                  .append('<img src="' + data.sizeListImageUrl + '" alt="img" class="single-image-product" />');
              }
              if (data.sizeListOptions == "<option value=\"uni\">UNI</option>") {
                  $('.fitguide__container--desktop').addClass('size-uni-active');
              }
              if (data.sizeListOptions) {
                $("select[name='choose-your-size']")
                  .empty()
                  .append(data.sizeListOptions);
              }
              if (data.tableDetails) {
                $('.measuring-guide__size-table .row')
                  .empty()
                  .append(data.tableDetails);
                $('#fitguide-content-01')
                  .css('display' , 'block');
                $('#fitguide-measurement-button')
                  .addClass('fitguide__tab-button--active')
                  .closest('.tab-button')
                  .css('display' , 'flex');

                let selectedSizePDP = $('.fsb-button').length ? $('.fsb-button').text().replace(/&nbsp;/g, '').toLowerCase() : '';
                if(selectedSizePDP !== '' && $("#choose-your-size option[value='" + selectedSizePDP + "']").length > 0) {
                  $("select[name='choose-your-size']")
                  .val(selectedSizePDP)
                  .trigger('change');
                }

                if (!data.fitGuideContentAsset) {
                  $('#fitguide-measurement-button')
                    .closest('.tab-button')
                    .siblings('.empty-col')
                    .addClass('col-md-12')
                    .css('border-left' , '0');
                  $('.click-to-convert-sizes')
                    .css('display' , 'none');
                }
              }
              if (data.fitGuideContentAsset) {
                sizeConversionAccordion ? sizeConversionAccordion.classList.remove('d-none') : null;
                  $('.measuring-guide-container')
                  .empty()
                  .append(data.fitGuideContentAsset);
                $('#fitguide-sizes-button')
                  .closest('.tab-button')
                  .css('display' , 'flex');
                if (!data.tableDetails) {
                  $('#fitguide-sizes-button')
                    .addClass('fitguide__tab-button--active')
                    .closest('.tab-button')
                    .siblings('.empty-col')
                    .addClass('col-md-10');
                  $('#fitguide-content-02')
                    .css('display' , 'block');
                }
              }
              if (data.genderlessGuideContentAsset) {
                genderSizeConversionAccordion ? genderSizeConversionAccordion.classList.remove('d-none') : null;
                $('.fitguige-sizes .measuring-guide-container')
                  .empty()
                  .append(data.genderlessGuideContentAsset);
              }
              if(data.bodyMeasurementsData && Object.keys(data.bodyMeasurementsData).length > 0) {
                const bodyMeasurementContent = bodyMeasurementTemplate(data.bodyMeasurementsData);
                if(bodyMeasuresAccordion) {
                  bodyMeasuresAccordion.classList.remove('d-none');
                }
                $('#body-measures .measuring-guide-container').empty()
                .append(bodyMeasurementContent);

                bodyMeasurementSwitchButtons = document.querySelectorAll('.body-measures-accordion .mm-switch .mm-switch__toggle');
                if(bodyMeasurementSwitchButtons) {
                  bodyMeasurementSwitchButtons = document.querySelectorAll('.fitguide__content .jils-change-unit-measure');
                  initUnitSizeChangeBehaviour(bodyMeasurementSwitchButtons);
                  bodyMeasurementSwitchButtons.forEach(btn => toggleButtonClick(btn));
                }
                if(productMeasurementSwitchButtons) {
                  productMeasurementSwitchButtons = document.querySelectorAll('.product-measures-accordion .mm-switch .mm-switch__toggle');
                  productMeasurementSwitchButtons.forEach(btn => toggleButtonClick(btn));
                }
              }
              if(Object.keys(data.fitGuide).length > 0) {
                productMeasuresAccordion ? productMeasuresAccordion.classList.remove('d-none') : null;
                const productMeasureInput = document.querySelector('#product-measures #interactive-unit-measure_0');
                productMeasureInput ? productMeasureInput.setAttribute('checked', true) : null;
              }
              columnAndRowHighlight();
            }
          },
          error: (error) => {
            alert('error');
          },
        });
      }
  });
}

const toggleButtonClick = (btn) => {
  if(btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      let selectedUnitMeasure = e.target && e.target.classList.contains('unit-measure') ? e.target.value : e.target.querySelector('.unit-measure').value;
      let selectedFitGuideSection = e.target.closest('.form-group.mm-switch').getAttribute('id');
      const isBodyMeasurementSection = selectedFitGuideSection === 'body-measurements-switch';
      const isProductMeasurementSection = selectedFitGuideSection === 'product-measurements-switch';

      if(isProductMeasurementSection) {
        productMeasurementSwitchButtons.forEach(b => b.classList.remove('-active'));
      } else if(isBodyMeasurementSection) {
        bodyMeasurementSwitchButtons.forEach(b => b.classList.remove('-active'));
      }

      e.target.closest('.mm-switch__toggle').classList.add('-active');

      if(selectedUnitMeasure) {
        if(selectedUnitMeasure == 'in') {
          if(isBodyMeasurementSection) {
            document.querySelectorAll('.body-measure-table tbody .js-values .js-cm').forEach(cms => {
              cms.classList.contains('d-none') ? null : cms.classList.add('d-none');
            });
            document.querySelectorAll('.body-measure-table tbody .js-values .js-in').forEach(ins => {
              ins.classList.remove('d-none');
            });
          } else if (isProductMeasurementSection) {
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-cm').forEach(cms => {
              cms.classList.contains('d-none') ? null : cms.classList.add('d-none');
            });
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-in').forEach(ins => {
              ins.classList.remove('d-none');
            });
          }
        } else {
          if(isBodyMeasurementSection) {
            document.querySelectorAll('.body-measure-table tbody .js-values .js-in').forEach(ins => {
              ins.classList.contains('d-none') ? null : ins.classList.add('d-none');
            });
            document.querySelectorAll('.body-measure-table tbody .js-values .js-cm').forEach(cms => {
              cms.classList.remove('d-none');
            });
          } else if (isProductMeasurementSection) {
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-in').forEach(ins => {
              ins.classList.contains('d-none') ? null : ins.classList.add('d-none');
            });
            document.querySelectorAll('.single-detail-content .table-details-value ._measures-cm').forEach(cms => {
              cms.classList.remove('d-none');
            });
          }
        }
      }
    })
  }

}

const updateCartAction = () => {
  $('.update-cart-product-global').on('click', function (e) {
    e.preventDefault();
    let updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
    let selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
    let selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
    let uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
    const pid = e.target && e.target.getAttribute('data-pid') || '';

    let form = {
      uuid: uuid,
      pid: pid,
      quantity: selectedQuantity,
      selectedOptionValueId: selectedOptionValueId,
    };
    $(this).parents('.card').spinner().start();
    if (updateProductUrl) {
      $.ajax({
        url: updateProductUrl,
        type: 'post',
        context: this,
        data: form,
        dataType: 'json',
        success: function (data) {
          const editProductModal = document.getElementById('edit-product-modal');
          document.querySelector('.error-message.invalid-selected-product') ? document.querySelector('.error-message.invalid-selected-product').classList.add('hidden') : null;
          editProductModal && editProductModal.classList.remove('is-open');
          // document.getElementById('main-overlay').style.display = 'none';
          document.getElementById('cart-show').style.height = '100%';
          document.getElementById('cart-show').style.overflow = 'auto';
          $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
          updateCartTotals(data.cartModel);
          updateApproachingDiscounts(data.cartModel.approachingDiscounts);
          updateAvailability(data.cartModel, uuid);
          updateProductDetails(data, uuid);

          if(data.cartModel.valid.error) {
            if(clickedProduct) {
              clickedProduct.classList.add('unavailable-item');
              const productErrorMessage = clickedProduct.querySelector('.product-message.d-none');
              productErrorMessage && productErrorMessage.classList.remove('d-none');
            }
          }

          let el = $('.productuuid-' + uuid).find("input[name='quantity']");
          el.attr('data-pid', data.newProductId);

          if (data.uuidToBeDeleted) {
            $('.uuid-' + data.uuidToBeDeleted).remove();
          }

          validateBasket(data.cartModel);
          // const clickedProductClass = clickedProduct && clickedProduct.classList[0]
          // $(`.${clickedProductClass} .detail-attribute.size .value-field`).text(clickedSize);
          $('body').trigger('cart:update');
          document.getElementById('main-overlay').classList.remove('no-top');

          // Tealium event "Modify Product Confirm"
          $('body').trigger('cart:productModified', data);
          $.spinner().stop();
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            document.querySelector('.error-message.invalid-selected-product') && document.querySelector('.error-message.invalid-selected-product').classList.remove('d-none');
            $.spinner().stop();
          }
        },
      });
    }
  });
};

const attributeClickBehaviour = () => {
  $('#edit-product-modal .swatch-attribute-value').on('click', (e) => {
    e.preventDefault();
    clickedSize = e.currentTarget.dataset.attrDisplayValue;
    currentOpenedModal = e.target.closest('.modal-content');

    // MCR-654
    // When user clicks on size button update color url attribute with the correct selected size
    const oldSizeElement = currentOpenedModal && currentOpenedModal.querySelector('.swatch-attribute-value.do_selectsize.selected');
    const oldSizeValue = oldSizeElement && oldSizeElement.getAttribute('data-attr-value');
    const colorInputElements = currentOpenedModal && currentOpenedModal.querySelectorAll('.color-attribute.selectable .swatch-attribute-value');
    colorInputElements.forEach(c => {
      const colorUrl = c.getAttribute('data-url');
      if(colorUrl && oldSizeValue && clickedSize) {
        // size could have ½, so remove ½ from previous size then use the integer number with %C2%BD string
        const halfSizeWithoutFraction = oldSizeValue.split('½') && oldSizeValue.split('½')[0];
        const halfSize = `_size=${halfSizeWithoutFraction}%C2%BD&`;
        const fullSize = `_size=${oldSizeValue}&`;
        const sizeToReplace = colorUrl.indexOf(halfSize) >= 0 ? halfSize : fullSize;
        const newUrl = colorUrl.replace(`${sizeToReplace}`, `_size=${clickedSize}&`);
        c.setAttribute('data-url', newUrl);
      }
    });

    // const $product = $(e.currentTarget);
    // const sizePidUrl = e.target.dataset.url || e.target.closest('.swatch-attribute-value').dataset.url;
    currentOpenedModal && currentOpenedModal.querySelectorAll('.swatch-attribute-value').forEach((val) => {
        val.classList.remove('selected');
        val.parentElement.classList.remove('selected');
    });

    e.currentTarget.parentElement.classList.add('selected');
    e.currentTarget.classList.add('selected');

    if(e.target && e.target.classList.contains('js-swatch-circle')) {
      const assistiveTextes = currentOpenedModal.querySelectorAll('.selected-assistive-text');
      assistiveTextes.forEach(t => t.classList.remove('selected-description'));
      const currentSelectedColor = e.target.closest('.color-attribute');
      const currentSeletedColorAssistiveText = currentSelectedColor && currentSelectedColor.querySelector('.selected-assistive-text');
      currentSeletedColorAssistiveText && currentSeletedColorAssistiveText.classList.add('selected-description');
    }
    // const selectInput = b.querySelector('input');
    // if(selectInput && selectInput.classList.contains('selected')) {
    //   b.querySelector('.selected-assistive-text').classList.add('d-none');
    // } else {
    //   b.querySelector('.selected-assistive-text').classList.remove('d-none');
    // }



    // currentOpenedModal.querySelectorAll('.product-color-variant').forEach(c => c.classList.remove('selected-description'));
    // currentOpenedModal.querySelector(`p[data-value-id="value-${colorID}"]`).classList.add('selected-description');

    // const colorBox = e.target && e.target.closest('.color-attribute.selectable');
    // const newColor = colorBox && colorBox.querySelector('.swatch-attribute-value.swatch-circle.selected');


    // const assistiveTexes = currentOpenedModal.querySelectorAll('.selected-assistive-text');
    // assistiveTexes && assistiveTexes.forEach(t => )

    // if (sizePidUrl) {
    //   $.ajax({
    //     url: sizePidUrl,
    //     type: 'get',
    //     context: this,
    //     data: $product.serialize(),
    //     dataType: 'json',
    //     success: function (data) {
    //       debugger;
    //       updatedPid = data.product.id;
    //       updateWishlistButton(e.target, data.product.inWishList);
    //       if(data.product.notifyWhenAvailableHtml.length >= 1) {
    //         $('.edit-product-modal .update-cart-product-global').addClass('disabled');
    //         $('.edit-product-modal .update-cart-product-global').attr('disabled', true);
    //       } else {
    //         $('.edit-product-modal .update-cart-product-global.disabled').removeClass('disabled');
    //         $('.edit-product-modal .update-cart-product-global').removeAttr('disabled');
    //       }
    //       $.spinner().stop();
    //     },
    //     error: function (err) {
    //       if (err.responseJSON && err.responseJSON.redirectUrl) {
    //         window.location.href = err.responseJSON.redirectUrl;
    //       } else {
    //         createErrorNotification(err.responseJSON.errorMessage);
    //         $.spinner().stop();
    //       }
    //     },
    //   });
    // }
  });
}

function initFunction() {
  $('.cart-body-section .cart-edit-link').on('click', function (e) {
    const $product = $(e.currentTarget);
    clickedProduct = e.target.closest('.product-wrapper');
    e.preventDefault();
    const pid = $(this).data('pid');
    selectedProductUUID = $(this).closest('.product-wrapper.js-lineitem') && $(this).closest('.product-wrapper.js-lineitem').data('product-uuid');
    let editProductUrl = $(this).data('href');

    if (pid) {
      editProductUrl += '&pid=' + pid;
    }

    // let errorObj = document.querySelector('.cart-error-messaging');
    // if (errorObj) document.querySelector('.cart-error-messaging').classList.add('d-none');

    $.ajax({
      url: editProductUrl,
      type: 'GET',
      dataType: 'json',
      data: $product.serialize(),
      beforeSend: function () {
        $.spinner().start();
      },
      success: function (data) {
        if (data.error) {
          $('.promo-code-form .form-control').addClass('is-invalid');
          $product.find('.invalid-feedback').append(data.errorMessage).removeClass('d-none');
        } else {
          // Tealium event "Modify Prodcut Popup Open"
          $('body').trigger('cart:modifyProductOpen');
          getModalHtmlElement();
          fillModalElement(editProductUrl);
        }

        // $('.coupon-code-field').val('');//
        $.spinner().stop();

        setTimeout(function () {
          $('.coupon-code-field').val('');
          $('.promo-code-form .form-control').removeClass('is-valid');
          $('.promo-code-form .form-control').removeClass('is-invalid');
        }, 2000);
      },
      error: function (err) {
        if (err.responseJSON && err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        } else {
          createErrorNotification(err.errorMessage);
          $.spinner().stop();
        }
      },
    });
  });

  attributeClickBehaviour();
  updateCartAction();

  // $('#close-edit-product-modal').on('click', () => {
  //   document.getElementById('editProductModal').classList.remove('show');
  //   document.getElementById('main-overlay').style.display = 'none';
  //   document.querySelector('body header.header').classList.add('z-index-0');
  //   document.getElementById('cart-show').style.height = '100vh';
  //   document.querySelector('body').style.overflow = 'auto';
  // });

  $('#size-guidelines-modal .modal-close').on('click', () => {
    setTimeout(() => {
      document.getElementById('size-guidelines-modal').classList.remove('is-open');
    }, 50);
  });
}

$(document).ready(function () {
  processInclude(require('core/cart/coupon'));

  // Commented out this line to prevent Tealium events from double-loading. To be fixed later
  //processInclude(require('tealium/tealiumEvents'));

  processInclude(require('adobeTarget/loadRecommendations'));
  // processInclude(require('./product/productCarousel'));
  processInclude(require('./tooltip'));

  // const dutiesTooltipBox = document.querySelector('.tooltip-global-container .duties-tooltip-box');
  // const taxesTooltipBox = document.querySelector('.tooltip-global-container .taxes-tooltip-box');
  // $('.tooltip-global-container .duties-tooltip-toggler').on('mouseover', () => dutiesTooltipBox.classList.add('visible'));
  // $('.tooltip-global-container .duties-tooltip-toggler').on('mouseleave', () => dutiesTooltipBox.classList.remove('visible'));
  // $('.tooltip-global-container .taxes-tooltip-toggler').on('mouseover', () => taxesTooltipBox.classList.add('visible'));
  // $('.tooltip-global-container .taxes-tooltip-toggler').on('mouseleave', () => taxesTooltipBox.classList.remove('visible'));
  initFunction();
  if(document.querySelector('.unavailable-item')) {
    createErrorNotification();
  }
});
